import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';
import {ProvisionConfigCheckResultDto} from '../../model/dto/api/provision-config-check-result.dto';

/**
 * API client for the ProvisionType configuration-check endpoint (03-architektur-backend.md §12.1;
 * cw CwCaseTypeConfigCheckApiService mirror, PAT §I.2). Read-only, on-demand — the backend runs
 * the CR-001…CR-032 catalog and returns a flat, code-ordered result (no persistence). Consumed by
 * the `configCheck` nav item of the ProvisionType object page
 * (`cp-provision-type-base.component.ts`, 04 §6) — Checkreport-Panel with severity + jump-to-
 * object (cw Bauform, PAT §I). There is no top-level config-page nav item for it.
 */
@Injectable({
    providedIn: 'root'
})
export class CpConfigCheckService {

    private readonly baseUrl = MvsCrudService.baseUrl + '/cp/configCheck';

    constructor(private http: HttpClient) {
    }

    /** GET /cp/configCheck/provisionType/{id} — full CR-001…CR-032 configuration check for one ProvisionType. */
    checkProvisionType(provisionTypeId: number): Observable<ProvisionConfigCheckResultDto> {
        return this.http.get<ProvisionConfigCheckResultDto>(`${this.baseUrl}/provisionType/${provisionTypeId}`);
    }

}
